import firebase from 'firebase'

  /*var config = {
    apiKey: process.env.REACT_APP_apiKey,
    authDomain: process.env.REACT_APP_authDomain,
    databaseURL: process.env.REACT_APP_databaseURL,
    projectId: process.env.REACT_APP_projectId,
    storageBucket: process.env.REACT_APP_storageBucket,
    messagingSenderId: process.env.REACT_APP_messagingSenderId
  };*/
  var config = {
    apiKey: "AIzaSyB_SWgc4lziipGvr7S5B3iPkwE5Fj10yew",
    authDomain: "verfid-db.firebaseapp.com",
    databaseURL: "https://verfid-db.firebaseio.com",
    projectId: "verfid-db",
    storageBucket: "verfid-db.appspot.com",
    messagingSenderId: "484263079318"
  };
 

  firebase.initializeApp(config);

  const database = firebase.database();
  const auth = firebase.auth();

  export { firebase, database, auth };


// WEBPACK FOOTER //
// ./src/utils/firebase.js